var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42317",
    "data-name": "Group 42317",
    transform: "translate(-17878 -19176)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15863",
    "data-name": "Rectangle 15863",
    width: 24,
    height: 24,
    transform: "translate(17878 19176)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "approved",
    transform: "translate(17825.461 19167.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37184",
    "data-name": "Path 37184",
    d: "M64.991,28.791H56V10H66.619l3.823,3.844v8.964",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 1.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3246",
    "data-name": "Line 3246",
    x2: 6.796,
    transform: "translate(59.782 16.509)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2992",
    "data-name": "Ellipse 2992",
    cx: 4.131,
    cy: 4.131,
    r: 4.131,
    transform: "translate(64.813 22.739)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37187",
    "data-name": "Path 37187",
    d: "M327.866,382.25l-1.911,1.911-.956-.956",
    transform: "translate(-257.505 -356.353)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 1.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3250",
    "data-name": "Line 3250",
    x2: 6.796,
    transform: "translate(59.782 19.351)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3251",
    "data-name": "Line 3251",
    x2: 1.699,
    transform: "translate(59.766 22.271)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmForm);
export default __webpack_public_path__ + "static/media/confirm-form.1927a3d8da8029174a3c6f68969687a3.svg";
export { ForwardRef as ReactComponent };